export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/26be91621103d1e1d9379798a79a6219.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      aria-label="Hero section introducing Alberto Rocha and the Consistency Paradox"
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-3xl">
          
          {/* Main Headline */}
          <div className="mb-6">
            <span className="inline-block px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-full mb-4">
              New Book Available
            </span>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              <strong>AI</strong> Is More <strong>Human</strong> Than <strong>Humans</strong>
            </h2>
            <p className="text-2xl text-gray-700 mb-4 font-medium">
              Exploring the <strong>Consistency Paradox</strong>
            </p>
          </div>

          {/* Subheadline */}
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Discover how <strong>AI's perfect consistency</strong> reveals the beautiful inconsistency of <strong>human nature</strong>. 
            Former Congressional appointee and <strong>AI ethics expert</strong> <strong>Alberto Rocha</strong> explores what makes us authentically human 
            in an age of <strong>artificial intelligence</strong>.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#book"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              Get the Book
            </a>
            <a
              href="#speaking"
              className="bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              Book Alberto to Speak
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap gap-6 items-center text-gray-600">
            <div className="flex items-center gap-2">
              <i className="ri-government-line text-2xl text-teal-600"></i>
              <span className="text-sm">Former Congressional Appointee</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-building-line text-2xl text-teal-600"></i>
              <span className="text-sm">CEO &amp; Technology Leader</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mic-line text-2xl text-teal-600"></i>
              <span className="text-sm">International Speaker</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
